import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import API from '../utils/api';
import encodeParams from '../utils/queryParam'

const initialState = {
  isLoading: false,
  data: {
    currentPage: 0,
    hasNext: false,
    hasPrevious: false,
    pageSize: 0,
    totalCount: 0,
    totalPages: 0,
    items: []
  },
  detail: {},
  contact: [],
};

const slice = createSlice({
  name: 'business',
  initialState,
  reducers: {
    getList(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    setPending(state, action) {
      state.isLoading = true;
    },
    getById(state, action) {
      state.isLoading = false;
      state.detail = action.payload;
    },
  }
});

export const reducer = slice.reducer;

export const getBusinessById = (orgId, businessId) => async (dispatch) => {
  dispatch(slice.actions.setPending());
  const url = `${API.URL_ORGANIZATION}/${orgId}/action/GetBusinessById/${businessId}`
  const response = await axios.get(url);
  dispatch(slice.actions.getById(response.data.data));
};


export default slice;
